import { IonSegment, IonSegmentButton, IonLabel } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSegmentSelected } from "../../../store/documentSupervisorShow";
import { selectSegmentSelected } from "../../../store/documentSupervisorShow/selectors/selectSegmentSelected";
import { DocumentHistory } from "./DocumentHistory";
import { DocumentInfo } from "./DocumentInfo";
import { DocumentSigners } from "./DocumentSigners";

export const SegmentsSection = () => {
  const dispatch = useDispatch();
  const segmentSelected = useSelector(selectSegmentSelected);
  return (
    <section className="ion-padding">
      <IonSegment
        onIonChange={(e) => {
          dispatch(setSegmentSelected(e.detail.value || ""));
        }}
        value={segmentSelected}
        style={{ maxWidth: "600px" }}
        scrollable
      >
        <IonSegmentButton value="info">
          <IonLabel>Documento</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value="signers">
          <IonLabel>Participantes</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value="history">
          <IonLabel>Historial</IonLabel>
        </IonSegmentButton>
      </IonSegment>

      <section className="ion-margin-top">
        {segmentSelected === "info" && <DocumentInfo />}
        {segmentSelected === "signers" && <DocumentSigners />}
        {segmentSelected === "history" && <DocumentHistory />}
      </section>
    </section>
  );
};
